module.exports = __webpack_public_path__ + "assets/img/how-to-donate-img-1.a7c22c0a.jpg";